export const PAGE_LOADER = "PAGE_LOADER";
export const SECTION_LOADER = "SECTION_LOADER";
export const MODAL_LOADER = "MODAL_LOADER";
